__turbopack_context__.v({
  "arrow": "Select-module__k3wHdG__arrow",
  "combo": "Select-module__k3wHdG__combo",
  "container": "Select-module__k3wHdG__container",
  "disabled": "Select-module__k3wHdG__disabled",
  "large": "Select-module__k3wHdG__large",
  "medium": "Select-module__k3wHdG__medium",
  "small": "Select-module__k3wHdG__small",
  "tiny": "Select-module__k3wHdG__tiny",
});
